// extracted by mini-css-extract-plugin
export default {"pageTitle":"AdminPeopleView_pageTitle__q08Cb","searchWrap":"AdminPeopleView_searchWrap__Lsja2"};